import {memo, useCallback, useMemo, useState} from 'react';
import {useIdleTimer} from 'react-idle-timer';

import {InactivityLayer as InactivityLayerUI} from '@/components/InactivityLayer';
import {
  AFTER_INACTIVITY_SCROLL_TARGET,
  INACTIVITY_TIMEOUT,
} from '@/modules/common/components/InactivityLayer/consts';
import {useConsent} from '@/modules/common/context/Consent';
import {useTracking} from '@/modules/common/hooks/useTracking';

export const InactivityLayer = memo(function InactivityLayer() {
  const {dispatchGenericTrackingEvent} = useTracking();
  const [isInactive, setIsInactive] = useState(false);

  const onIdle = () => {
    setIsInactive(true);
    dispatchGenericTrackingEvent({
      event: 'gaNonEvent',
      eventAction: 'Impression',
      eventCategory: 'Inactivity Banner',
    });
  };
  const {status} = useConsent();

  const timeout = useMemo(() => {
    const timeoutFromStorage = localStorage.getItem('inactivityTimer');
    const timeoutOverride = timeoutFromStorage
      ? Number.parseInt(timeoutFromStorage, 10)
      : INACTIVITY_TIMEOUT;

    return timeoutOverride >= 0 ? timeoutOverride : INACTIVITY_TIMEOUT;
  }, []);

  useIdleTimer({
    onIdle,
    timeout,
  });

  const handleUpdateButtonClick = useCallback(() => {
    dispatchGenericTrackingEvent({
      event: 'gaEvent',
      eventAction: 'Angebote aktualisieren',
      eventCategory: 'Inactivity Banner',
    });
    setIsInactive((previousState) => !previousState);
    document.getElementById(AFTER_INACTIVITY_SCROLL_TARGET)?.scrollIntoView();
    window.location.reload();
  }, [dispatchGenericTrackingEvent]);
  if (status === null) {
    return null;
  }
  return (
    <InactivityLayerUI
      open={isInactive}
      onUpdateBtnClick={handleUpdateButtonClick}
    />
  );
});
